<template>
  <ion-page>
    <master-layout pageTitle="پیشخوان">
      <ion-card-content>

        <ion-grid>
          <ion-row>
            <ion-col v-if="currentUser && currentUser.menus && currentUser.menus.indexOf('order_add')>-1" size="4">
              <MainPageItem icon="bags-shopping" itemTitle="ثبت سفارش" url="/Order/Add"></MainPageItem>
            </ion-col>

            <ion-col v-if="currentUser && currentUser.menus && currentUser.menus.indexOf('customer_list')>-1" size="4">
              <MainPageItem icon="users-cog" itemTitle="لیست مشتریان" url="/Customer/list"></MainPageItem>
            </ion-col>

            <ion-col v-if="currentUser && currentUser.menus && currentUser.menus.indexOf('map')>-1" size="4">
              <MainPageItem icon="map" itemTitle="نقشه" url="/CustomerMap"></MainPageItem>
            </ion-col>

            <ion-col v-if="currentUser && currentUser.menus && currentUser.menus.indexOf('order_list')>-1" size="4">
              <MainPageItem icon="shopping-basket" itemTitle="سفارشات مشتریان" url="/order/list"></MainPageItem>
            </ion-col>

            <ion-col v-if="currentUser && currentUser.menus && currentUser.menus.indexOf('visit')>-1"  size="4">
              <MainPageItem icon="map-marked-alt" itemTitle="مأموریت ویزیت" url="/mission/Manage"></MainPageItem>
            </ion-col>

            <ion-col v-if="currentUser && currentUser.menus && currentUser.menus.indexOf('deliver')>-1" size="4">
              <MainPageItem icon="truck" itemTitle="مأموریت توزیع" url="/DeliverMission/Manage"></MainPageItem>
            </ion-col>

            <ion-col v-if="currentUser && currentUser.menus && currentUser.menus.indexOf('payment_mission')>-1" size="4">
              <MainPageItem icon="hand-holding-usd" itemTitle="مأموریت مطالبات" url="/PaymentMission/Manage"></MainPageItem>
            </ion-col>

            <ion-col v-if="currentUser && currentUser.menus && currentUser.menus.indexOf('warehouse')>-1" size="4">
              <MainPageItem icon="warehouse-alt" itemTitle="موجودی انبار" url="/Warehouse/Manage"></MainPageItem>
            </ion-col>

            <ion-col v-if="false" size="4">
              <MainPageItem icon="car" itemTitle="بانک اطلاعات خودرو" url="/cars"></MainPageItem>
            </ion-col>

            <ion-col v-if="currentUser && currentUser.menus && currentUser.menus.indexOf('reports')>-1" size="4">
              <MainPageItem icon="chart-bar" itemTitle="گزارشات" url=""></MainPageItem>
            </ion-col>

            <ion-col v-if="currentUser && currentUser.menus && currentUser.menus.indexOf('income')>-1" size="4">
              <MainPageItem icon="sack-dollar" itemTitle="درآمدها" url="/commission/Manage"></MainPageItem>
            </ion-col>

            <ion-col v-if="currentUser && currentUser.menus && currentUser.menus.indexOf('receive_doc')>-1" size="4">
              <MainPageItem icon="hands-usd" itemTitle="دریافتی ها" url="/incoming/Manage"></MainPageItem>
            </ion-col>

            <ion-col v-if="false && currentUser.can_deliver" size="4">
              <MainPageItem icon="truck-couch" item-title="حواله های ارسالی" url="/SendOrder/List"></MainPageItem>
            </ion-col>
            <ion-col v-if="currentUser && currentUser.menus && currentUser.menus.indexOf('catalog')>-1" size="4">
              <MainPageItem icon="newspaper" item-title="کاتالوگ محصولات" url="/Catalog/List"></MainPageItem>
            </ion-col>

          </ion-row>
        </ion-grid>

      </ion-card-content>
    </master-layout>
  </ion-page>
</template>


<script>

import {mapGetters} from "vuex";
import MainPageItem from '/src/components/MainPageItem'
import {
  IonCardContent, IonPage, IonGrid, IonCol, IonRow, useBackButton, toastController, useIonRouter
} from "@ionic/vue";

export default {
  data()
  {
    return{
      menus : ['order_add','customer_list','map','order_list','visit','deliver','payment_mission','warehouse','reports','income','receive_doc','catalog'],
    }
  },
  components: {
    IonCardContent, IonGrid, IonCol, IonRow, MainPageItem, IonPage
  },
  setup()
  {
    let backButtonTime = 0;
    const ionRouter = useIonRouter();
    useBackButton(-1, async (processNextHandler) =>
    {
      if (!ionRouter.canGoBack())
      {
        if ((new Date().getTime() - backButtonTime) < 3500)
          navigator['app'].exitApp();
        else
        {
          const toast = await toastController.create({
            header: '',
            message: 'برای خروج دکمه بازگشت را بزنید',
            duration: 2000,
            position: 'bottom',
            color: 'danger'
          });
          await toast.present();
          backButtonTime = new Date().getTime()
        }
      }
      processNextHandler();
    });
  },
  computed: {
    ...mapGetters("auth", {
      currentUser: "getUserInfo",
    }),
  },
  mounted()
  {
    if(!this.currentUser.menus || !this.currentUser.menus.length)
      this.currentUser.menus = this.menus;
  }
};
</script>

<style scoped>
ion-card-content {
  height: 100%;
  padding: 0!important;
  background: transparent!important;
}
</style>